<template>
<div class="CreateMissionGameOverlay">
  <div class="container-fluid">
    <div id="myNav" class="overlay overlay-overall-width-100Perc">
      <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc container-fluid">
        <div class="row margin-left-1Point6Perc">
          <div class="col-md-7 col-lg-7 text-align-left padding-left-0px margin-Top-1Point5Perc create-element-overlay-course-title-font-styles">
            {{getCurrentlySelectedCourseObj.CourseTitle}}
          </div>    
          <div class="col-md-5 col-lg-5">
            <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="udpateCloseCreateElementOverlay($event,false)">
              <img src= "../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
            </div>  
          </div>
        </div>
        <div class="row margin-left-1Point5Perc padding-left-0px padding-bottom-1Perc bottom-border margin-bottom-2Perc">
          <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles padding-left-0px">
            {{lessonObj.Title}}
          </div>    
        </div>
        <div class="row vertical-align padding-bottom-15px">  
          <div class="create-lesson-input-text-style font-size-14px col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Title
          </div> 
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12 padding-left-0px padding-right-0px">
                <input class="form-control inputdefault" type="text" maxlength="73" v-model="MissionTitleValue">
              </div>
            </div>
          </div>
          <div class="col-md-3 col-lg-3 checkbox text-align-right padding-right-0px">
            <label><input type="checkbox" value="false" v-model="DisableCheckinValue">Disable "No" option for check-ins</label>
          </div>
          <div class="col-md-3 col-lg-3 checkbox text-align-right margin-top-10px">
            <label><input type="checkbox" value="true" v-model="MissionIncludeInProgress">Include In Progress</label>
          </div>
          <div class="col-md-1 col-lg-1"></div>  
        </div>
        <div class="row vertical-align padding-bottom-18px">  
          <div class="create-lesson-input-text-style font-size-14px col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Mission Brief
          </div>
          <div class="col-md-4 col-lg-4 padding-right-0px">
            <div class="form-group">
              <div class="col-sm-12 padding-left-0px">
                <div class="cursor-pointer" @click="openCourseDescOverlay($event, true)">+ RTF Description</div>
              </div>
            </div>
          </div>
          <div class="col-md-2 col-lg-2">
            <b>Or</b>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12 padding-left-0px padding-right-0px">
                <input type="file" id="toolkitfile" accept=".pdf">
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div>  
        </div>
        <div class="row vertical-align padding-bottom-4px">
          <div class="create-lesson-input-text-style font-size-14px col-md-1 col-lg-1 text-align-right padding-left-0px padding-right-0Px">
            Duration
          </div>
          <div class="col-md-4 col-lg-4">
            <input type="text" class="form-control" v-model="MissionDurationValue" placeholder="MM:SS">
          </div>
          <div class="col-md-7 col-lg-7"></div>
        </div> 
        <div class="row padding-top-15px container-fluid vertical-align">
          <div class="col-md-12 col-lg-12 border-1px">
            <div class="col-md-6 col-lg-6 padding-top-15px">
              <div class="row padding-4px margin-bottom-2Perc">
                <div class="col-md-12 col-lg-12">
                  <div class="font-size-20px create-lesson-input-text-style col-md-12 col-lg-12">
                    Opening Question Alert
                  </div>  
                </div>
              </div>  
              <div class="row vertical-align">
                <div class="col-md-2 col-lg-2 padding-right-0px text-align-right">Title</div>   
                <div class="col-md-9 col-lg-9">
                  <input type="text" class="form-control inputdefault" maxlength="73" v-model="MissionOpeningAlertTitleValue">
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row padding-top-15px padding-bottom-15px">
                <div class="col-md-2 col-lg-2 padding-left-0px padding-right-0px text-align-right">Description</div>   
                <div class="col-md-9 col-lg-9">
                  <textarea class="form-control" rows="5" cols="5" maxlength="256" v-model="MissionOpeningAlertDescValue"></textarea>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div> 
            </div>
            <div class="col-md-6 col-lg-6 border-left-1px padding-top-15px">
              <div class="row font-size-20px create-lesson-input-text-style margin-bottom-2Perc">
                <div class="col-md-12 col-lg-12 padding-4px">
                  Closing Question Alert
                </div>
              </div>
              <div class="row vertical-align">
                <div class="col-md-2 col-lg-2 padding-right-0px text-align-right">Title</div>   
                <div class="col-md-9 col-lg-9">
                  <input type="text" class="form-control inputdefault" maxlength="73" v-model="MissionClosingAlertTitleValue">
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row padding-top-15px padding-bottom-15px">
                <div class="col-md-2 col-lg-2 padding-left-0px padding-right-0px text-align-right">Description</div>   
                <div class="col-md-9 col-lg-9">
                  <textarea class="form-control" rows="5" maxlength="256" v-model="MissionClosingAlertDescValue"></textarea>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
            </div>
          </div> 
        </div>
        <div class="row margin-bottom-2Perc margin-Top-2Perc" v-if="!showMissionInputUI">  
          <button class="btn btn-primary create-lesson-overlay-button-BG black-font-color padding-6px-43px" @click="createMission" v-if="!showMissionInputUI">Next</button>
        </div> 
        <div class="row container-fluid">
          <mission-input-layout v-if="showMissionInputUI" :MissionGameResp="getMissionResponseObj" :lessonObj="getLessonObj" @HideMainMissionOverlay="hideMainMissionOverlayScreen" @openMissionOverlay="closeCurrentMissionOverlay" @OverallQuestionList="updateOverallQuestionList"></mission-input-layout>  
        </div>
        <div class="row container-fluid">
          <mission-check-ins-layout v-if="showMissionInputUI && getClosingQuestionListValue.length > 0" :MissionGameResp="getMissionResponseObj" :lessonObj="getLessonObj" :missionCheckinAndJourney="getMissionCheckinsWithJourneyValue" @addMissionCheckIns="emitMissionCheckInToParent"></mission-check-ins-layout>
        </div>
        <div class="row margin-bottom-2Perc margin-top-2Perc">  
          <button class="btn btn-primary create-lesson-overlay-button-BG black-font-color btn-padding-6px-35px" v-if="showMissionInputUI && getClosingQuestionListValue.length > 0" v-on:click="udpateCloseCreateElementOverlay($event,false)">Done</button>
        </div>        
      </div>
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>
    <add-rtf-course-description-overlay v-if="openDescriptionOverlay" @closeRtfEditorOverlay="closeRTFEditor" :addedDescription="MissionBriefValue"></add-rtf-course-description-overlay>
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="resetCurrentGameFlow"></confirmation-alert>
   </div>
  </div>
</template>

<script>
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import Loader from '@/components/dashboard/Loader'
import AlertBox from '@/components/AlertOverlay'
import MissionInputLayout from '@/components/mission_game/missionInputOverlay'
import { constants } from '@/utils/constants'
import { elementService } from '@/server-util/element-service'
import MissionCheckInsLayout from '@/components/mission_game/MissionCheckIns'
import AddRTFCourseDescriptionOverlay from '@/components/AddRTFCourseDescriptionOverlay'
import lodash from 'lodash'

export default {
  props: ['lessonObj'],
  created: function () {
    this.setDefaultvalues()
    this.GetLearningLevels()
  },
  data: function () {
    return {
      showConfirmationBox: false,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      prefixString: '',
      postString: '',
      elementObj: {
        ModuleId: '',
        Title: '',
        Description: '',
        IncludeInProgress: false,
        DisableNoOption: false,
        OpeningAlertTitle: '',
        OpeningAlertMessage: '',
        ClosingAlertTitle: '',
        ClosingAlertMessage: '',
        Type: 12,
        File: null,
        Duration: '',
        learningLevelId: ''
      },
      missionGameResp: {},
      missionCheckinsWithJourney: {},
      showMissionInputUI: false,
      hideMissionDescRTFEditor: false,
      openDescriptionOverlay: false,
      hideData: {
        ModuleIndex: '',
        ElementIndex: ''
      },
      openingQuestionList: [],
      closingQuestionList: []
    }
  },
  name: 'CreateMissionGameOverlay',
  methods: {
    closeRTFEditor (value) {
      this.openDescriptionOverlay = value.closeRtfEditorOverlay
      this.MissionBriefValue = value.description
      this.$store.state.isOverlayVisible = value.closeRtfEditorOverlay
    },
    openCourseDescOverlay: function (event, flagToUpdate = false) {
      this.openDescriptionOverlay = flagToUpdate
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    updateOverallQuestionList (value) {
      this.openingQuestionList = value.openingQuestionList
      this.closingQuestionList = value.closingQuestionList
      // console.log('updateOverallQuestionList: ' + JSON.stringify(value))
    },
    emitMissionCheckInToParent (value) {
      // console.log('Add Mission CheckIn Object: ' + JSON.stringify(value))
    },
    closeCurrentMissionOverlay (value) {
      this.$store.state.isLoading = true
      this.$emit('refreshElementList', true)
      this.$emit('openOverlay', value)
    },
    hideMainMissionOverlayScreen (value) {
      var closeMissionOverlay = value.closeOverlay
      var _this = this
      setTimeout(function () {
        _this.hideMissionDescRTFEditor = closeMissionOverlay
      }, 700)
      setTimeout(function () {
        _this.elementObj.Description = _this.getMissionResponseObj.Description
      }, 1000)
      console.log('_this.elementObj.Description >>> ' + _this.elementObj.Description)
    },
    chekckToolkitFileExtesion: function (fileName) {
      var exts = ['.pdf']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    validateRequiredFieldBeforeSubmit: function () {
      var regex = /^(?:([0-5]?\d):)?([0-5]?\d)$/g
      var fileUrl = document.getElementById('toolkitfile').files[0]
      if (this.MissionTitleValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        return false
      } else if ((this.MissionBriefValue === null || this.MissionBriefValue.trim().length === 0) && fileUrl === undefined) {
        this.showAlertDialog = true
        this.errorMsg = 'Mission Brief can\'t be empty.'
        return false
      } else if ((this.MissionBriefValue !== null && this.MissionBriefValue.trim().length > 0) && fileUrl !== undefined) {
        this.showAlertDialog = true
        this.errorMsg = 'Mission Brief can either be in Text or PDF format.'
        return false
      } else if (fileUrl !== undefined && !this.chekckToolkitFileExtesion(document.getElementById('toolkitfile').value)) {
        this.showAlertDialog = true
        this.errorMsg = 'Invalid file format detected. You need to use a .pdf file.'
        return false
      } else if ((this.MissionDurationValue.trim().length !== 0 && this.MissionDurationValue.indexOf(':') === -1)) {
        this.showAlertDialog = true
        this.errorMsg = 'Duration format should be MM:SS.'
        return false
      } else if (this.elementObj.IncludeInProgress && this.MissionDurationValue.length > 0 && !regex.test(this.MissionDurationValue)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please enter a valid duration.'
        return false
      } else if (this.MissionOpeningAlertTitleValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Opening alert title can\'t be empty.'
        return false
      } else if (this.MissionOpeningAlertDescValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Opening alert description can\'t be empty.'
        return false
      } else if (this.MissionClosingAlertTitleValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Closing alert title can\'t be empty.'
        return false
      } else if (this.MissionClosingAlertDescValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Closing alert description can\'t be empty.'
        return false
      }
      return true
    },
    createMission: function () {
      if (this.validateRequiredFieldBeforeSubmit()) {
        var fileUrl = document.getElementById('toolkitfile').files[0]
        if (fileUrl === undefined || fileUrl === null || fileUrl === 'null') {
          fileUrl = null
        }
        const formData = new FormData()
        formData.append('ModuleId', this.elementObj.ModuleId)
        formData.append('Title', this.elementObj.Title)
        formData.append('Description', this.elementObj.Description)
        formData.append('Type', this.elementObj.Type)
        formData.append('DisableNoOption', this.elementObj.DisableNoOption)
        formData.append('OpeningAlertTitle', this.elementObj.OpeningAlertTitle)
        formData.append('OpeningAlertMessage', this.elementObj.OpeningAlertMessage)
        formData.append('ClosingAlertTitle', this.elementObj.ClosingAlertTitle)
        formData.append('ClosingAlertMessage', this.elementObj.ClosingAlertMessage)
        formData.append('IncludeInProgress', this.elementObj.IncludeInProgress)
        formData.append('Duration', this.elementObj.Duration)
        formData.append('LearningLevelId', this.elementObj.learningLevelId)
        formData.append('File', fileUrl)
        var _this = this
        var storeObj = this.$store
        if (formData !== undefined || formData !== '' || formData !== undefined) {
          this.$store.state.isLoading = true
          elementService
            .createMissionGameElement(storeObj.state.access_token, formData)
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  _this.missionGameResp = responseObj.data
                  console.log('Mission Game Response >>> ' + JSON.stringify(_this.missionGameResp))
                  _this.getMissionCheckinsAndCourseJourney()
                } else {
                  // AK: Hide Spinner
                  _this.$store.state.isLoading = false
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                }
              },
              errorObj => {
                // AK: Hide Spinner
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                if (errorObj.response === undefined) {
                  this.errorMsg = constants.No_Internet_Connection_Msg
                } else {
                  this.errorMsg = errorObj.response.statusText
                }
              }
            )
        } else {
          console.log(
            'Selected FormData is NULL hence declined CREATE MISSION OPERATION'
          )
        }
      }
    },
    getMissionCheckinsAndCourseJourney: function () {
      var _this = this
      var storeObj = this.$store
      if (this.missionGameResp.ElementId !== undefined && this.missionGameResp.ElementId !== '' && this.missionGameResp.ElementId !== 'null') {
        this.$store.state.isLoading = true
        elementService
          .getMissionCheckinWithCourseJourney(storeObj.state.access_token, _this.missionGameResp.ElementId, true)
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                _this.missionCheckinsWithJourney = responseObj.data
                _this.showMissionInputUI = true
                _this.$store.state.isLoading = false
              } else {
                // AK: Hide Spinner
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
              }
            },
            errorObj => {
              // AK: Hide Spinner
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'Selected Mission Element Id is NULL hence declined GET MISSION CHECKIN AND COURSE JOURNEY OPERATION'
        )
      }
    },
    checkAndProccessData: function () {
      const currMissionModuleId = this.getMissionResponseObj.ModuleId
      const currMissionElementId = this.getMissionResponseObj.ElementId
      var currModuleObj = lodash.find(this.getLessonList, function (o) {
        return o.ModuleId === currMissionModuleId
      })
      if (currModuleObj !== undefined && currModuleObj !== null && currModuleObj !== '' && currModuleObj !== 'null') {
        this.hideData.ModuleIndex = currModuleObj.Index
        // console.log('currMissionElementId: ' + currMissionElementId)
        // console.log('currModuleObj.Elements: ' + currModuleObj.Elements)
        var currElementObj = null
        for (var i = 0; i < currModuleObj.Elements.length; i++) {
          const currObj = currModuleObj.Elements[i]
          if (currObj.ElementId === currMissionElementId) {
            currElementObj = currObj
            break
          }
        }
        this.hideData.ElementIndex = currElementObj.Index
        console.log('Current Module Name where Mission inserted ' + JSON.stringify(currModuleObj.Index))
        console.log('Current Element Name where Mission inserted ' + JSON.stringify(currElementObj.Index))
      }
    },
    setDefaultvalues: function () {
      this.elementObj.ModuleId = this.getLessonObj.ModuleId
    },
    updateShowConfirmationAlertFlag (value) {
      this.showConfirmationBox = value
    },
    udpateCloseCreateElementOverlay: function (event, flagToUpdate) {
      this.$store.state.isLoading = true
      this.$emit('refreshElementList', true)
      this.$emit('openOverlay', flagToUpdate)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    GetLearningLevels: function () {
      // var _this = this
      var storeObj = this.$store
      elementService
      .getLearningLevels(storeObj.state.access_token)
      .then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          // console.log('respond status', responseObj.data.CreatedTS)
          // this.learningLevelId = responseObj.data
          storeObj.state.learningLevelList = responseObj.data
        } else {
            //  Hide Spinner
            // _this.$emit('showSpinner', false)
          this.showAlertDialog = true
          this.errorMsg = 'Oops! Something went wrong. Please try again.'
        }
      }, errorObj => {
        //  Hide Spinner
        // _this.$emit('showSpinner', false)
        this.showAlertDialog = true
        if (errorObj.response === undefined) {
          this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          this.errorMsg = errorObj.response.statusText
        }
      })
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'confirmation-alert': ConfirmationOverlay,
    'mission-input-layout': MissionInputLayout,
    'mission-check-ins-layout': MissionCheckInsLayout,
    'add-rtf-course-description-overlay': AddRTFCourseDescriptionOverlay
  },
  computed: {
    getOpeningQuestionListValue: {
      get: function () {
        return this.openingQuestionList
      }
    },
    getClosingQuestionListValue: {
      get: function () {
        return this.closingQuestionList
      }
    },
    getLessonList: {
      get: function () {
        return this.getMissionCheckinsWithJourneyValue.CourseJourney.Modules
      }
    },
    getMissionCheckinsWithJourneyValue: {
      get: function () {
        return this.missionCheckinsWithJourney
      }
    },
    getCurrentlySelectedCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    getLessonObj: {
      get: function () {
        return this.lessonObj
      }
    },
    getMissionResponseObj: {
      get: function () {
        // console.log('Mission Game Overlay >>> ' + JSON.stringify(this.missionGameResp))
        return this.missionGameResp
      }
    },
    MissionTitleValue: {
      get: function () {
        return this.elementObj.Title
      },
      set: function (newValue) {
        this.elementObj.Title = newValue
      }
    },
    DisableCheckinValue: {
      get: function () {
        return this.elementObj.DisableNoOption
      },
      set: function (newValue) {
        this.elementObj.DisableNoOption = newValue
      }
    },
    MissionBriefValue: {
      get: function () {
        return this.elementObj.Description
      },
      set: function (newValue) {
        this.elementObj.Description = newValue
      }
    },
    MissionIncludeInProgress: {
      get: function () {
        return this.elementObj.IncludeInProgress
      },
      set: function (newValue) {
        this.elementObj.IncludeInProgress = newValue
      }
    },
    MissionOpeningAlertTitleValue: {
      get: function () {
        return this.elementObj.OpeningAlertTitle
      },
      set: function (newValue) {
        this.elementObj.OpeningAlertTitle = newValue
      }
    },
    MissionOpeningAlertDescValue: {
      get: function () {
        return this.elementObj.OpeningAlertMessage
      },
      set: function (newValue) {
        this.elementObj.OpeningAlertMessage = newValue
      }
    },
    MissionClosingAlertTitleValue: {
      get: function () {
        return this.elementObj.ClosingAlertTitle
      },
      set: function (newValue) {
        this.elementObj.ClosingAlertTitle = newValue
      }
    },
    MissionClosingAlertDescValue: {
      get: function () {
        return this.elementObj.ClosingAlertMessage
      },
      set: function (newValue) {
        this.elementObj.ClosingAlertMessage = newValue
      }
    },
    MissionDurationValue: {
      get: function () {
        return this.elementObj.Duration
      },
      set: function (newValue) {
        this.elementObj.Duration = newValue
      }
    },
    elementLearningLevelObjValue: {
      get: function () {
        console.log('Learning Object value', this.elementObj.learningLevelId)
        if (this.elementObj.learningLevelId !== undefined && this.elementObj.learningLevelId !== null && this.elementObj.learningLevelId !== '' && this.elementObj.learningLevelId !== 'null') {
          return this.elementObj.learningLevelId
        } else {
          return -1
        }
      },
      set: function (newValue) {
        this.elementObj.learningLevelId = newValue
      }
    },
    getLearningLevelList: {
      get: function () {
        // console.log('Learning List ++', this.$store.learningLevelList)
        return this.$store.state.learningLevelList
      }
    }
  },
  watch: {}
}
</script>

<style scoped>
.CreateMissionGameOverlay {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-4Perc
{
	margin-bottom: 4%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}
.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.overflow-x-hidden {
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 10%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 3% !important;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
    border:1px solid red;
}
.dotted-border {
  border-bottom: 1px dotted;
}
.padding-bottom-0Px {
  padding-bottom:0Px;
}
.font-size-20px {
  font-size:20px;
}
.padding-top-15px {
 padding-top:15px; 
}
.right-border {
  border-right: 1px solid #aaa;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.margin-left-1Point6Perc {
    margin-left: 1.6%;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.padding-left-20px {
  padding-left:20px;
}
.padding-left-28px {
  padding-left:28px;
}
.margin-bottom-15px {
  margin-bottom:15px;
}
.border-bottom-1px {
  border-bottom: 1px solid #aaa; 
}
.padding-left-0px {
  padding-left:0px;
}
.padding-right-0px {
  padding-right:0px;
}
.padding-bottom-10px {
  padding-bottom: 10px;
}
.height-10px {
  height: 10px;
}
.tooltip1 {
    position: relative !important;
    display: inline-block !important;
    /* border-bottom: 1px dotted black !important; */
}
.tooltip1 .tooltiptext1 {
    visibility: hidden;
    width: 90px;
    background-color: #696969;
    /* opacity:0.8; */
    color: #fff;
    text-align: left;
    border-radius: 6px;
    padding: 5px 5px;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    top: 107%;
    left: 35%;
    margin-left: -60px;
}
.tooltip1 .tooltiptext1::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #696969 transparent;
}
.tooltip1:hover .tooltiptext1 {
    visibility: visible;
}
.font-size-14px {
  font-size: 14px;
}
.padding-6px-43px {
  padding: 6px 43px;
}
.padding-bottom-15px {
  padding-bottom: 15px;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.border-1px {
  border-top: 1px solid #aaa !important;
  border-bottom: 1px solid #aaa !important;
  border-left: 1px solid #aaa !important;
  border-right: 1px solid #aaa !important;
}
/* .border-1px{
  border: 1px solid red;
} */
.border-left-1px {
  border-left: 1px solid #aaa !important;
}
.padding-6px {
  padding:6px;
}
.padding-4px {
  padding:4px;
}
.margin-top-10px {
  margin-top:10px;
}
.btn-padding-6px-35px {
  padding: 6px 35px;
}
.padding-bottom-18px {
  padding-bottom:18px;
}
.padding-bottom-4px {
  padding-bottom:4px;
}
</style>



// WEBPACK FOOTER //
// src/components/mission_game/MissionGameOverlay.vue